import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { MediaControllerRecentFilesAndFolders$Params } from '../../../api/fn/file-manager/media-controller-recent-files-and-folders';
import {
  DeletedItem,
  EntityMediaItem,
  FolderCreationResponse,
  MediaListFullResponse,
  MediaRecentListFullResponse,
  MediaStatsFullResponse,
  MovedItem,
  UploadedItem,
} from '../../../api/models';
import { MediaControllerListFilesAndFolders$Params } from '../../../api/fn/file-manager/media-controller-list-files-and-folders';
import { MediaControllerDeleteFile$Params } from '../../../api/fn/file-manager/media-controller-delete-file';
import { MediaControllerMoveFile$Params } from '../../../api/fn/file-manager/media-controller-move-file';
import { MediaControllerUploadFile$Params } from '../../../api/fn/file-manager/media-controller-upload-file';
import { MediaControllerMakeDir$Params } from '../../../api/fn/file-manager/media-controller-make-dir';
import { MediaControllerDownload$Params } from '../../../api/fn/file-manager/media-controller-download';
import { EntityMediaControllerUploadAndAttach$Params } from '../../../api/fn/file-manager-entita/entity-media-controller-upload-and-attach';

export const fileManagerAction = {
  recentsLoad: createAction('media/load/recents', props<MediaControllerRecentFilesAndFolders$Params>()),
  recentsDone: createAction(
    'media/load/recents/done',
    props<{ state: ILoaderActionPayload; data?: MediaRecentListFullResponse }>(),
  ),
  recentsSetState: createAction('media/load/recents/set-state', props<{ state: ILoaderActionPayload }>()),

  statsLoad: createAction('media/load/stats'),
  statsDone: createAction(
    'media/load/stats/done',
    props<{ state: ILoaderActionPayload; data?: MediaStatsFullResponse }>(),
  ),
  statsSetState: createAction('media/load/stats/set-state', props<{ state: ILoaderActionPayload }>()),

  folderLoad: createAction('media/load/folder', props<MediaControllerListFilesAndFolders$Params>()),
  folderDone: createAction(
    'media/load/folder/done',
    props<{ state: ILoaderActionPayload; data?: MediaListFullResponse }>(),
  ),
  folderSetState: createAction('media/load/folder/set-state', props<{ state: ILoaderActionPayload }>()),
  mkFolder: createAction('media/mk-folder', props<MediaControllerMakeDir$Params>()),
  mkFolderDone: createAction(
    'media/mk-folder/done',
    props<{ state: ILoaderActionPayload; data?: FolderCreationResponse; prefix: string }>(),
  ),
  mkFolderSetState: createAction('media/mk-folder/set-state', props<{ state: ILoaderActionPayload }>()),
  deleteOne: createAction('media/delete/file', props<MediaControllerDeleteFile$Params>()),
  deleteOneDone: createAction(
    'media/delete/file/done',
    props<{ state: ILoaderActionPayload; data?: DeletedItem; prefix: string }>(),
  ),
  deleteOneSetState: createAction('media/delete/file/set-state', props<{ state: ILoaderActionPayload }>()),
  moveOne: createAction('media/move/file', props<MediaControllerMoveFile$Params>()),
  moveOneDone: createAction('media/move/file/done', props<{ state: ILoaderActionPayload; data?: MovedItem }>()),
  moveOneSetState: createAction('media/move/file/set-state', props<{ state: ILoaderActionPayload }>()),
  uploadOne: createAction('media/upload/file', props<MediaControllerUploadFile$Params>()),
  uploadOneDone: createAction('media/upload/file/done', props<{ state: ILoaderActionPayload; data?: UploadedItem }>()),
  uploadOneSetState: createAction('media/upload/file/set-state', props<{ state: ILoaderActionPayload }>()),
  uploadEntityOne: createAction('media/upload/entity/file', props<EntityMediaControllerUploadAndAttach$Params>()),
  uploadEntityOneDone: createAction(
    'media/upload/entity/file/done',
    props<{ state: ILoaderActionPayload; data?: EntityMediaItem; entity_id: number }>(),
  ),
  uploadEntityOneSetState: createAction('media/upload/entity/file/set-state', props<{ state: ILoaderActionPayload }>()),
  downloadOne: createAction('media/download/file', props<MediaControllerDownload$Params>()),
  downloadOneDone: createAction(
    'media/download/file/done',
    props<{ state: ILoaderActionPayload; data?: { fileData: Blob } }>(),
  ),
  downloadOneSetState: createAction('media/download/file/set-state', props<{ state: ILoaderActionPayload }>()),
  resetState: createAction('media/reset-state'),
};
